document.addEventListener('DOMContentLoaded', () => {

  const input = document.querySelector('.learning-search input');

  if (!input) return;

  const allArticles = document.querySelectorAll(
    '.learning-category-item'
  );

  input.addEventListener('keyup', () => {

    const value = input.value.toLowerCase();

    allArticles.forEach(article => {

      const text = article.innerText.toLowerCase();

      if (text.includes(value)) {

        article.style.display = 'flex';

      } else {

        article.style.display = 'none';

      }

    });

  });

});